import {ModifierGroupFragment} from '../../../../gql/graphql';
import {ModifierModel} from './Modifier.model';
import {ModelContext} from '../../../../types/checkoutApp.types';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';
import {ModifierGroup} from '@wix/auto_sdk_ecom_cart-v-2';

export class ModifierGroupModel {
  public id: string;
  public name?: string;
  public modifiers: ModifierModel[];

  constructor(params: ModifierGroupModel) {
    this.id = params.id;
    this.name = params.name;
    this.modifiers = params.modifiers;
  }

  public static fromCheckoutV1(modifierGroup: ModifierGroupFragment, modelContext: ModelContext) {
    return new ModifierGroupModel({
      id: modifierGroup.id!,
      name: mapNullToUndefined(modifierGroup.name?.translated ?? modifierGroup.name?.original),
      modifiers: (modifierGroup.modifiers ?? []).map((modifier) =>
        ModifierModel.fromCheckoutV1(modifier!, modelContext)
      ),
    });
  }
  /* istanbul ignore next */
  public static fromCartV2(modifierGroup: ModifierGroup, modelContext: ModelContext): ModifierGroupModel {
    return new ModifierGroupModel({
      id: modifierGroup._id!,
      name: mapNullToUndefined(modifierGroup.name?.translated ?? modifierGroup.name?.original),
      modifiers: (modifierGroup.modifiers ?? []).map((modifier) => ModifierModel.fromCartV2(modifier, modelContext)),
    });
  }
}
